import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'src/utils/date';
import { LabelBodyProps } from './RunLabelBody';

export const LotLabelBody: React.FC<LabelBodyProps> = ({ product }) => {
  const { t } = useTranslation();
  return (
    <>
      <p>
        <label>{t('product.lotNo')}: </label>
        <span>{product.lotNo}</span>
      </p>
      <p>
        <label>{t('specification.pspNo')}: </label>
      </p>
      <p>
        <span>{product.specification.no}</span>
      </p>
      <p>
        <label>{t('grade.singular')}: </label>
        <span>{product.grade.name}</span>
      </p>
      <p>
        <label>{t('props.date')}: </label>
        <span>{formatDate(product.lotDate)}</span>
      </p>

      <textarea />
    </>
  );
};
